import { useTranslation } from "react-i18next";

import { SliderPageWrapper } from "../../../layout/sliderPageWrapper/SliderPageWrapper";

import classes from "./Confirmation.module.scss";
import { useRootDispatch } from "../../../../store/hooks";
import { updateSlide } from "../../../../store/common/common-slice";
import { useAssets } from "../../../../hooks/useAssets";

export interface ConfirmationProps { }

export const Confirmation: React.FC<ConfirmationProps> = () => {
  const { t } = useTranslation(["common", "payment_final"]);
  const dispatch = useRootDispatch();
  const { createAssetUrl } = useAssets();

  const addAnotherPaymentMethod = () => {
    dispatch(updateSlide({ id: "AddPaymentMethods" }));
  };

  return (
    <SliderPageWrapper headerTitle={t("common:add_payment_method")}>
      <div className={classes.PageWrapper}>
        <div className={classes.ModuleWrapper}>
          <div className={classes.ImageWrapper}>
            <img
              src={createAssetUrl("successful-action")}
              alt={"Congratulations"}
            />
          </div>
          <div className={classes.ConfirmationWrapper}>
            <p className={classes.ConfirmationWrapperHeading}>
              {t("payment_final:congratulations")}
            </p>
            <p className={classes.ConfirmationWrapperSummery}>
              {t("payment_final:congratulations_summery")}
            </p>
          </div>
          <div className={classes.ButtonWreapper}>
            <ft-button
              class={classes.AutoPay}
              label={t("payment_final:enroll_in_autopay")}
              unelevated
              onClick={() => {
                dispatch(updateSlide({ id: "ManageWallet", tab: 1 }));
              }}
            ></ft-button>
            <ft-button
              class={[classes.NewPay, "outline-button"].join(" ")}
              label={t("payment_final:add_another_payment_method",)}
              outlined
              onClick={addAnotherPaymentMethod}
            ></ft-button>
          </div>
        </div>
      </div>
    </SliderPageWrapper>
  );
};
